namespace Matrix.Data {
    export class SettingsColumns {
        static columnsKey = 'Data.Settings';
    }
}
